var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1387",
    "data-name": "Group 1387",
    transform: "translate(-6322 -3415)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2369",
    "data-name": "Rectangle 2369",
    width: 24,
    height: 24,
    transform: "translate(6322 3415)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "company",
    transform: "translate(6256.039 3406.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3006",
    "data-name": "Path 3006",
    d: "M65.961,188.512V200.26a.632.632,0,0,0,.632.632H89.329a.632.632,0,0,0,.632-.632V188.512a.632.632,0,0,0-.632-.632H84.277v-7.326a.632.632,0,0,0-.632-.632H80.8a.632.632,0,0,0,0,1.263h2.211v18.442H80.487V196.47a.632.632,0,0,0-.632-.632H76.066a.632.632,0,0,0-.632.632v3.158H72.908V181.186h9.175a.632.632,0,0,0,0-1.263H72.277a.632.632,0,0,0-.632.632v7.326H66.593A.632.632,0,0,0,65.961,188.512Zm18.316.632H88.7v10.484H84.277ZM76.7,197.1h2.526v2.526H76.7Zm-9.474-7.958h4.421v10.484H67.224Z",
    transform: "translate(0 -170.133)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3007",
    "data-name": "Path 3007",
    d: "M220.382,365.923h-3.789a.632.632,0,1,0,0,1.263h3.789a.632.632,0,1,0,0-1.263Z",
    transform: "translate(-140.526 -344.386)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3008",
    "data-name": "Path 3008",
    d: "M220.382,305.923h-3.789a.632.632,0,0,0,0,1.263h3.789a.632.632,0,0,0,0-1.263Z",
    transform: "translate(-140.526 -288.175)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3009",
    "data-name": "Path 3009",
    d: "M220.382,245.923h-3.789a.632.632,0,0,0,0,1.263h3.789a.632.632,0,0,0,0-1.263Z",
    transform: "translate(-140.526 -231.965)",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.3e845410.svg";
export { ForwardRef as ReactComponent };